import TongHop from './TongHop.jsx';
export {
  TongHop
};


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/tong-hop/index.js